// ============================================================================
// FIREBASE CONFIGURATION
// ============================================================================
// Replace these values with your Firebase project config.
// Get this from: Firebase Console > Project Settings > Your Apps > Config

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBaF85KsT8rIfVSXkyO_815TvxtgauSLRQ",
  authDomain: "cybergrid-assult.firebaseapp.com",
  projectId: "cybergrid-assult",
  storageBucket: "cybergrid-assult.firebasestorage.app",
  messagingSenderId: "576758568996",
  appId: "1:576758568996:web:f6faf029bb1fe37b4b20b1",
  measurementId: "G-QNLH88NB94"
};

// To set up Firebase:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project (or use existing)
// 3. Go to Project Settings > General > Your apps
// 4. Click "Add app" > Web (</>)
// 5. Register app and copy the config values above
// 6. Go to Firestore Database > Create database
// 7. Start in test mode (for development)
// 8. Set up security rules for production (see below)

/*
FIRESTORE SECURITY RULES (for production):

rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    // Rooms collection (WebRTC signaling)
    match /rooms/{roomCode} {
      allow read, write: if true; // For development
      // For production, add authentication:
      // allow read, write: if request.auth != null;
      
      // Peers subcollection
      match /peers/{peerId} {
        allow read, write: if true;
      }
      
      // Signals subcollection (for WebRTC signaling)
      match /signals/{peerId}/messages/{messageId} {
        allow read, write: if true;
      }
    }
    
    // Public Lobbies collection (for lobby browser)
    match /publicLobbies/{roomCode} {
      allow read: if true;   // Anyone can browse lobbies
      allow write: if true;  // For development
      // For production: validate lobby data structure
    }
    
    // Player Stats collection
    match /playerStats/{playerId} {
      allow read: if true;  // Anyone can read stats (for leaderboards)
      allow write: if true; // For development
      // For production with auth:
      // allow write: if request.auth != null && request.auth.uid == playerId;
    }
    
    // Global Stats (aggregate statistics)
    match /globalStats/{docId} {
      allow read: if true;   // Anyone can read global stats (for webpage)
      allow write: if true;  // For development
      // For production: use Cloud Functions to update
    }
  }
}
*/
